import { GPTGameIcon } from 'src/EXPERIMENTAL_LIB/modules/gpt/icons';

export const BonusEventIcon: GPTGameIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <g clip-path="url(#clip0_3026_522)">
      <path
        d="M18.51 14.95C18.1 17.04 17.68 18.8 17.43 19.01C16.82 19.56 10.46 21.47 9.51999 21.46C8.56999 21.46 2.95999 19.76 2.31999 19.01C2.23999 18.92 2.06999 18.23 1.84999 17.22C1.13999 13.86 -7.00355e-06 6.92 0.619993 6.54C1.40999 6.05 8.15999 4.52 10.38 4.49C12.61 4.46 19.15 6.84 19.5 7.46C19.71 7.83 19.14 11.77 18.52 14.95H18.51Z"
        fill="url(#paint0_linear_3026_522)"
      />
      <path
        opacity="0.5"
        d="M0.620001 6.54C-0.429999 7.1 7.52 9.7 9.12 9.7C10.72 9.7 19.27 7.63 19.5 7.46C19.74 7.29 12.56 4.47 10.23 4.49C7.9 4.51 0.940001 6.37 0.620001 6.53V6.54Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M9.52001 21.47C8.59001 21.35 8.84001 10.59 9.11001 10.14C9.38001 9.69 18.78 7.77 19.16 7.86C19.54 7.95 17.77 18.47 17.44 19.01C17.11 19.55 9.95001 21.52 9.53001 21.46L9.52001 21.47Z"
        fill="#3A0039"
      />
      <path
        opacity="0.74"
        d="M18.51 14.96C18.1 17.04 17.68 18.8 17.43 19.02C16.82 19.57 10.46 21.48 9.52001 21.47C8.57001 21.47 2.96001 19.77 2.32001 19.02C2.24001 18.93 2.07001 18.24 1.85001 17.23C1.91001 17.33 2.21001 18.76 3.13001 19.24C3.52001 19.45 7.89001 21.02 9.41001 20.99C10.93 20.96 16.39 19.95 17.18 18.71C17.95 17.49 18.5 15.05 18.52 14.96H18.51Z"
        fill="#9F679D"
      />
      <path
        opacity="0.5"
        d="M9.52001 21.47C9.17001 20.76 12.37 15.44 13.16 14.96C13.95 14.48 15.61 13.91 16.14 14.26C16.66 14.61 17.43 19.02 17.43 19.02C17.43 19.02 16.68 14.71 16.31 14.22L19.49 7.56C19.49 7.56 16.38 13.69 16.25 13.91C16.12 14.13 14.75 14.06 12.85 14.79L9.23001 10.06C9.23001 10.06 9.14001 10.03 9.11001 10.15C9.08001 10.27 12.36 14.09 12.37 14.97C12.38 15.85 9.36001 20.32 9.23001 20.71C9.10001 21.11 9.52001 21.48 9.52001 21.48V21.47Z"
        fill="#201261"
      />
      <path
        opacity="0.2"
        d="M10.18 20.61C10.18 20.61 12.27 15.88 13.2 15.47C14.13 15.06 15.97 14.53 16.33 14.67C16.68 14.8 17.38 18.64 17.26 18.98C17.14 19.32 12.57 20.94 11.17 21.11C9.77001 21.29 10.18 20.61 10.18 20.61Z"
        fill="#912790"
      />
      <path
        d="M3.58 8.23C3.58 8.23 7.97 9.99 8.76 10.08C9.55 10.17 18.3 8 18.84 7.76C19.38 7.52 19.45 7.49 19.45 7.49C19.45 7.49 10.8 9.6 9.22 9.46C6.51 9.22 3.58 8.23 3.58 8.23Z"
        fill="#EAD1E9"
      />
      <path
        d="M7.95 9.78C8.56 9.89 8.8 17.77 8.86 18.04C8.92 18.3 8.63 11.51 9.11 10.14L7.95 9.78Z"
        fill="#EAD1E9"
      />
      <path
        d="M8.10001 9.91C7.14 9.34 11.09 9.43 11.2 9.53C11.32 9.63 8.78 10.51 8.10001 9.91Z"
        fill="#FFEFFE"
      />
      <path
        opacity="0.2"
        d="M0.730001 7.86C0.860001 7.09 6.62 9.75 7.61 11.65C8.6 13.55 8.72 19.65 8.54 20.35C8.36 21.05 3.29 19.7 2.54 18.29C1.79 16.88 0.500001 9.3 0.740001 7.86H0.730001Z"
        fill="#C49FC2"
      />
      <path
        d="M6.94 20.87C6.94 20.87 6.48 21.07 6.19 21.03C5.91 20.99 4.37 20.71 4.22 20.54C4.07 20.37 1.82 8.42 2.16 7.68C2.49 6.94 8.74 6.04 9.11 6.15C9.48 6.26 10.18 6.65 10.18 6.65C10.18 6.65 5.65 8.1 5.14 8.53C4.64 8.97 6.28 20.58 6.3 20.66C6.32 20.75 6.94 20.85 6.94 20.85V20.87Z"
        fill="url(#paint1_linear_3026_522)"
      />
      <path
        d="M11.96 20.95C11.96 20.95 12.67 21.11 12.85 21.14C13.03 21.16 15.11 20.53 15.38 20.35C15.64 20.17 16.69 8.98 16.61 8.3C16.52 7.62 10.36 6.16 10.14 6.15C9.91 6.14 9.28 6.27 8.97 6.51C8.66 6.75 13.13 8.37 13.44 9.01C13.75 9.65 12.97 20.61 12.86 20.69C12.75 20.77 11.97 20.96 11.97 20.96L11.96 20.95Z"
        fill="url(#paint2_linear_3026_522)"
      />
      <path
        d="M9.33999 6.83C8.64999 6.64 4.48999 5.48 4.48999 5.48L3.25999 5.74C3.25999 5.74 3.43999 5.19 3.57999 5.13C3.71999 5.07 6.74999 4.38 7.28999 4.5C7.83999 4.62 10.71 6.57 10.71 6.57L9.33999 6.83Z"
        fill="url(#paint3_linear_3026_522)"
      />
      <path
        d="M16.61 6.08C16.61 6.08 16.61 5.82 16.52 5.66C16.43 5.5 13.78 4.75 13.52 4.73C13.26 4.71 9.12 6.29 9.12 6.29C9.12 6.29 9.8 6.59 10.27 6.66C10.74 6.73 15.87 5.83 15.97 5.83C16.07 5.83 16.61 6.08 16.61 6.08Z"
        fill="url(#paint4_linear_3026_522)"
      />
      <path
        opacity="0.74"
        d="M6.94 20.87C6.94 20.87 6.24 21.04 6.03 21C5.83 20.96 4.38 9.16 4.5 8.51C4.62 7.86 9.45 6.89 9.45 6.89C9.45 6.89 13.07 8.4 13.39 8.66C13.71 8.92 13.49 10.31 13.49 10.31C13.49 10.31 13.35 9.17 13.09 8.9C12.82 8.64 10.71 7.53 9.69 7.58C9.07 7.61 8.48 8.64 7.59 8.96C7.03 9.16 5.64 8.53 5.44 8.86C4.93 9.71 6.4 20.66 6.52 20.75C6.64 20.84 6.95 20.88 6.95 20.88L6.94 20.87Z"
        fill="#2E264D"
      />
      <path
        opacity="0.74"
        d="M10.23 7.26C10.23 7.26 13.65 7.6 15.8 7.31C17.95 7.02 16.79 6.14 16.79 6.14L9.66 7L10.22 7.26H10.23Z"
        fill="#27213A"
      />
      <path
        d="M10.56 6.83C10.56 6.83 10.51 6.83 10.44 6.85C10.41 6.85 10.38 6.87 10.34 6.89C9.54999 7.2 6.92999 8.56 6.46999 8.65C6.35999 8.67 6.11999 8.64 5.80999 8.56C4.60999 8.29 2.30999 7.51 2.13999 7.31C1.92999 7.07 0.0999941 2.41 2.33999 1.86C3.73999 1.52 5.65999 3.18 7.12999 4.45C8.01999 5.22 8.75999 5.85 9.11999 5.82C9.11999 5.82 9.66999 6.18 10.09 6.47C10.16 6.52 10.22 6.56 10.28 6.61C10.37 6.67 10.44 6.72 10.49 6.76C10.53 6.79 10.56 6.82 10.56 6.82V6.83Z"
        fill="url(#paint5_linear_3026_522)"
      />
      <path
        opacity="0.5"
        d="M6.43 8.36C5.66 8.66 5.14 4.64 5.29 3.99C5.44 3.34 7.99 6.63 9.58 6.65C11.17 6.67 6.6 8.29 6.43 8.36Z"
        fill="#450045"
      />
      <path
        opacity="0.74"
        d="M10.56 6.66L10.49 6.77L10.47 6.79L10.43 6.85L10.33 6.89C9.54 7.2 6.92 8.56 6.46 8.65C6.35 8.67 6.11 8.64 5.8 8.56C5.24 7.41 3.96 2.54 5.71 3.64C6.14 3.91 6.63 4.19 7.12 4.46C8.01 5.23 8.75 5.86 9.11 5.83C9.11 5.83 9.66 6.19 10.08 6.48C9.83 6.22 9.7 5.94 9.67 5.88C10.02 6.1 10.3 6.3 10.44 6.46C10.51 6.53 10.55 6.6 10.56 6.66Z"
        fill="#2E001E"
      />
      <path
        d="M16.42 6.36C15.95 6.84 11.12 7.08 10.53 6.89C10.49 6.88 10.44 6.86 10.4 6.83C10.4 6.83 10.36 6.81 10.34 6.8C10.28 6.76 10.22 6.72 10.17 6.68C10.11 6.63 10.06 6.58 10.02 6.52C9.81999 6.28 9.70999 6.02 9.67999 5.97C10.11 5.97 11.8 1.19 12.38 0.69C12.92 0.22 16.59 0.39 18.06 1.1C18.22 1.18 18.35 1.25 18.44 1.35C19.43 2.27 16.92 5.88 16.43 6.38L16.42 6.36Z"
        fill="url(#paint6_linear_3026_522)"
      />
      <path
        opacity="0.5"
        d="M10.54 6.59C10.54 6.59 12.25 6.13 13.69 5.41C15.84 4.32 16.87 2.07 17.77 1.97C18.7 1.86 17.3 5.73 15.59 6.26C14.03 6.74 10.54 6.6 10.54 6.6V6.59Z"
        fill="#20041F"
      />
      <path
        opacity="0.74"
        d="M16.42 6.36C15.95 6.84 11.12 7.08 10.53 6.89C10.49 6.88 10.44 6.86 10.4 6.83C10.4 6.83 10.36 6.83 10.3 6.85L10.23 6.96L10.21 6.88L10.16 6.66C10.16 6.66 10.16 6.64 10.16 6.63C10.18 6.58 10.23 6.53 10.3 6.48C10.87 6.09 13.03 5.64 14.42 4.31C16.24 2.56 16.83 1.25 18.03 1.07C18.19 1.15 18.32 1.22 18.41 1.32C19.4 2.24 16.89 5.85 16.4 6.35L16.42 6.36Z"
        fill="#2D071F"
      />
      <path
        d="M8.87 5.78C8.87 5.78 10.2 5.44 10.99 5.78C11.78 6.12 11.6 6.71 11.51 6.97C11.42 7.23 9.85 7.1 9.85 7.1C9.85 7.1 9.94 6.8 9.81 6.37C9.68 5.94 8.86 5.78 8.86 5.78H8.87Z"
        fill="url(#paint7_linear_3026_522)"
      />
      <path
        opacity="0.74"
        d="M10.17 5.71C10.17 5.71 11.06 3.81 11.78 2.39C12.57 0.84 15.4 1.54 15.35 2.76C15.29 3.94 11.92 5.73 11.4 5.81C10.9 5.89 10.17 5.71 10.17 5.71Z"
        fill="#FF5CC5"
        fill-opacity="0.4"
      />
      <path
        opacity="0.74"
        d="M10.71 5.8C10.71 5.8 11.57 5.61 12.03 5.06C12.5 4.48 12.24 2.67 11.91 2.74C11.58 2.81 10.18 5.7 10.18 5.7L10.72 5.79L10.71 5.8Z"
        fill="#FF5CC5"
      />
      <path
        opacity="0.3"
        d="M1.58001 2.35C1.40001 2.68 3.55001 2.7 4.06001 3.4C4.56001 4.1 4.86001 3.48 5.26001 3.4C5.66001 3.32 3.78001 2.06 2.76001 2.04C1.74001 2.02 1.57001 2.35 1.57001 2.35H1.58001Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M12.04 1.34C11.87 1.62 13.79 1.05 14.75 1.52C15.73 2.01 16.63 1.59 17 1.22C17.38 0.84 12.86 0 12.04 1.34Z"
        fill="white"
      />
      <path
        opacity="0.74"
        d="M15.3 4.25C14.42 5.14 15.82 6.14 16.07 6.07C16.32 6 18.13 3.82 17.93 2.59C17.72 1.33 16.92 2.61 15.3 4.25Z"
        fill="#2D001D"
      />
      <path
        opacity="0.74"
        d="M5.47 6.27C5.55 6.61 8.9 6.7 9.11 6.65C9.32 6.6 7.64 5.87 6.68 4.87C5.72 3.86 5.38 3.85 5.29 3.99C5.2 4.14 5.41 6.01 5.47 6.27Z"
        fill="#2A001B"
      />
      <path
        d="M0.860004 11.65C0.860004 11.65 0.420004 8.27 0.690004 7.43C0.960004 6.59 1.27 6.28 1.27 6.28C1.27 6.28 0.690004 6.37 0.510004 6.56C0.330004 6.75 0.330004 7.85 0.850004 11.66L0.860004 11.65Z"
        fill="#92BDFF"
      />
      <path
        d="M0.520004 6.69C0.540004 6.96 0.790004 7.01 0.850004 6.96C0.910004 6.9 1.11 6.41 1.11 6.41C1.11 6.41 0.510004 6.44 0.530004 6.69H0.520004Z"
        fill="#D6E6FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.21 15.62C7.21 15.62 7.75 14 8.14 13.45C8.14 13.45 11.51 14.52 12.12 16.72C12.12 16.72 10.92 20.96 9.13 19.95C7.34 18.94 7.2 15.62 7.2 15.62H7.21Z"
        fill="url(#paint8_linear_3026_522)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.53 15.62C20.53 15.62 19.99 14 19.6 13.45C19.6 13.45 16.23 14.52 15.62 16.72C15.62 16.72 16.82 20.96 18.61 19.95C20.4 18.94 20.54 15.62 20.54 15.62H20.53Z"
        fill="url(#paint9_linear_3026_522)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.59 13.32C23.59 13.32 21.03 13.31 19.27 16.04C19.62 16.36 19.84 16.85 19.84 17.4C19.84 18.35 19.18 19.13 18.36 19.13C17.54 19.13 16.88 18.36 16.88 17.4C16.88 16.76 17.17 16.21 17.61 15.91C16.95 14.78 15.81 13.35 13.93 12.2C12.04 13.35 10.9 14.8 10.24 15.93C10.66 16.23 10.95 16.78 10.95 17.41C10.95 18.36 10.29 19.14 9.47 19.14C8.65 19.14 7.99 18.37 7.99 17.41C7.99 16.84 8.22 16.34 8.58 16.03C6.82 13.31 4.28 13.33 4.28 13.33C6.26 16.57 6.47 20.2 6.44 22.15C6.01 22.15 6.17 22.25 6.17 22.25C6.17 22.25 6.26 23.19 13.89 23.39C21.57 23.59 21.74 22.15 21.74 22.15C21.74 22.15 21.54 22.18 21.41 22.19C21.38 20.25 21.6 16.59 23.59 13.33V13.32Z"
        fill="url(#paint10_linear_3026_522)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.59 19.13C9.59 19.13 9.51 19.13 9.47 19.13C8.65 19.13 7.99 18.36 7.99 17.4C7.99 16.83 8.22 16.33 8.58 16.02C7.15 13.81 5.15 13.35 4.28 13.31C4.28 13.31 4.52 13.31 4.51 13.31C4.51 13.31 7.05 13.3 8.81 16.01C8.45 16.33 8.22 16.83 8.22 17.39C8.22 18.3 8.82 19.04 9.58 19.11L9.59 19.13Z"
        fill="url(#paint11_linear_3026_522)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.28 19.13C18.28 19.13 18.36 19.13 18.4 19.13C19.22 19.13 19.88 18.36 19.88 17.4C19.88 16.83 19.65 16.33 19.29 16.02C20.72 13.81 22.72 13.35 23.59 13.31C23.59 13.31 23.35 13.31 23.36 13.31C23.36 13.31 20.82 13.3 19.06 16.01C19.42 16.33 19.65 16.83 19.65 17.39C19.65 18.3 19.05 19.04 18.29 19.11L18.28 19.13Z"
        fill="url(#paint12_linear_3026_522)"
      />
      <g filter="url(#filter0_d_3026_522)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.94 23.13C9.64 23.13 6.24 22.66 6.14 22.18V22.58C6.14 23.13 9.63 23.57 13.94 23.57C18.25 23.57 21.75 23.13 21.75 22.58C21.75 22.58 21.75 22.26 21.75 22.13C21.65 22.08 21.42 22.13 21.42 22.13C21.42 22.68 18.26 23.13 13.95 23.13H13.94Z"
          fill="url(#paint13_linear_3026_522)"
        />
      </g>
      <path
        opacity="0.6"
        d="M13.94 23.13C18.25 23.13 21.75 22.69 21.75 22.14L21.42 22.18C21.28 22.46 17.98 22.84 13.95 22.84C9.91999 22.84 6.63999 22.53 6.44999 22.14C6.44999 22.14 6.35999 22.14 6.26999 22.14C6.17999 22.14 6.14999 22.18 6.14999 22.18C6.19999 22.62 9.64999 23.12 13.94 23.12V23.13Z"
        fill="white"
      />
      <g filter="url(#filter1_d_3026_522)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.94 21.13C9.64 21.13 6.24 20.66 6.14 20.18V20.58C6.14 21.13 9.63 21.57 13.94 21.57C18.25 21.57 21.75 21.13 21.75 20.58C21.75 20.58 21.75 20.26 21.75 20.13C21.65 20.08 21.42 20.13 21.42 20.13C21.42 20.68 18.26 21.13 13.95 21.13H13.94Z"
          fill="url(#paint14_linear_3026_522)"
        />
      </g>
      <path
        opacity="0.6"
        d="M13.94 21.13C18.25 21.13 21.75 20.69 21.75 20.14L21.42 20.18C21.28 20.46 17.98 20.84 13.95 20.84C9.91999 20.84 6.63999 20.53 6.44999 20.14C6.44999 20.14 6.35999 20.14 6.26999 20.14C6.17999 20.14 6.14999 20.18 6.14999 20.18C6.19999 20.62 9.64999 21.12 13.94 21.12V21.13Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3026_522"
        x="-8.86"
        y="12.1078"
        width="35.61"
        height="21.4622"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.847059 0 0 0 0 0.54902 0 0 0 0 0.207843 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3026_522" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3026_522"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3026_522"
        x="-8.86"
        y="10.1078"
        width="35.61"
        height="21.4622"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.847059 0 0 0 0 0.54902 0 0 0 0 0.207843 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3026_522" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3026_522"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3026_522"
        x1="9.98999"
        y1="21.47"
        x2="9.98999"
        y2="4.49"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFD4FC" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3026_522"
        x1="6.15"
        y1="21.03"
        x2="6.15"
        y2="6.14"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#A90086" />
        <stop offset="1" stop-color="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3026_522"
        x1="12.78"
        y1="21.13"
        x2="12.78"
        y2="6.14"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#A90086" />
        <stop offset="1" stop-color="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3026_522"
        x1="6.98999"
        y1="6.83"
        x2="6.98999"
        y2="4.48"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#E82E86" />
        <stop offset="1" stop-color="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3026_522"
        x1="12.86"
        y1="6.66"
        x2="12.86"
        y2="4.73"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#E82E86" />
        <stop offset="1" stop-color="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3026_522"
        x1="5.88999"
        y1="8.65"
        x2="5.88999"
        y2="1.82"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#A90086" />
        <stop offset="1" stop-color="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3026_522"
        x1="14.16"
        y1="6.96"
        x2="14.16"
        y2="0.41"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#A90086" />
        <stop offset="1" stop-color="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3026_522"
        x1="10.23"
        y1="7.13"
        x2="10.23"
        y2="5.63"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#A90086" />
        <stop offset="1" stop-color="#FF2457" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3026_522"
        x1="7.21"
        y1="16.77"
        x2="12.13"
        y2="16.77"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F49E29" />
        <stop offset="1" stop-color="#A54801" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_3026_522"
        x1="20.98"
        y1="15.63"
        x2="15.51"
        y2="18.54"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#EAAE29" />
        <stop offset="1" stop-color="#7D3801" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_3026_522"
        x1="4.28"
        y1="17.8"
        x2="23.59"
        y2="17.8"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FADA40" />
        <stop offset="0.03" stop-color="#F1C734" />
        <stop offset="0.12" stop-color="#DD9A18" />
        <stop offset="0.19" stop-color="#D07E06" />
        <stop offset="0.23" stop-color="#CC7400" />
        <stop offset="0.29" stop-color="#DC7C00" />
        <stop offset="0.34" stop-color="#EC8500" />
        <stop offset="0.39" stop-color="#EE950C" />
        <stop offset="0.47" stop-color="#F5C12D" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.71" stop-color="#FFFBE2" />
        <stop offset="0.73" stop-color="#FDF3C5" />
        <stop offset="0.78" stop-color="#FBE699" />
        <stop offset="0.82" stop-color="#F9DC74" />
        <stop offset="0.87" stop-color="#F8D558" />
        <stop offset="0.91" stop-color="#F7CF44" />
        <stop offset="0.96" stop-color="#F7CC38" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_3026_522"
        x1="5.73"
        y1="12.8"
        x2="8.77"
        y2="19.73"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FCE3A1" />
        <stop offset="0.07" stop-color="#FCDF8B" />
        <stop offset="0.18" stop-color="#FCD96F" />
        <stop offset="0.25" stop-color="#FDD865" />
        <stop offset="0.48" stop-color="#FDE19B" />
        <stop offset="0.83" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_3026_522"
        x1="22.14"
        y1="12.8"
        x2="19.1"
        y2="19.73"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.24" stop-color="#FCE3A1" />
        <stop offset="0.28" stop-color="#FCDF8B" />
        <stop offset="0.34" stop-color="#FCD96F" />
        <stop offset="0.38" stop-color="#FDD865" />
        <stop offset="0.55" stop-color="#FFEBA8" />
        <stop offset="0.72" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_3026_522"
        x1="6.27"
        y1="23.01"
        x2="21.88"
        y2="22.87"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9D83F" />
        <stop offset="0.11" stop-color="#F2AB1D" />
        <stop offset="0.2" stop-color="#ED8F07" />
        <stop offset="0.25" stop-color="#EC8500" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.69" stop-color="#FCF2BD" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_3026_522"
        x1="6.17"
        y1="21.01"
        x2="21.78"
        y2="20.86"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9D83F" />
        <stop offset="0.11" stop-color="#F2AB1D" />
        <stop offset="0.2" stop-color="#ED8F07" />
        <stop offset="0.25" stop-color="#EC8500" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.69" stop-color="#FCF2BD" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <clipPath id="clip0_3026_522">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
